export  default{
    emptySpace:' '
};